import { useEffect, useRef, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import styles from './Billing.module.css';

/** Native modality contains keyboard focus and restores it on close. */
export function BillingDialog({
  titleId,
  onClose,
  children,
  dismissible = true,
}: {
  titleId: string;
  onClose: () => void;
  children: ReactNode;
  dismissible?: boolean;
}) {
  const ref = useRef<HTMLDialogElement>(null);
  const previous = useRef(document.activeElement as HTMLElement | null);
  const close = useRef(onClose);
  close.current = onClose;
  useEffect(() => {
    const dialog = ref.current!;
    dialog.showModal();
    return () => {
      dialog.close();
      if (previous.current?.isConnected) previous.current.focus();
    };
  }, []);
  return createPortal(
    <dialog
      ref={ref}
      className={styles.dialog}
      aria-labelledby={titleId}
      onCancel={(event) => {
        event.preventDefault();
        if (dismissible) close.current();
      }}
    >
      {children}
    </dialog>,
    document.body,
  );
}
